export const siteWidth = 1280
